import { HTMLInputTypeAttribute, useState } from "react";
import { ReactComponent as EditIcon } from "../../assets/icons/tables/edit-icon.svg";
import { ReactComponent as TrashIcon } from "../../assets/icons/tables/trash-icon.svg";
import { Tooltip } from "@material-tailwind/react";

interface Props {
  label?: string;
  leftValue?: string;
  rightValue?: string;
  leftOnChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  rightOnChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  leftType?: HTMLInputTypeAttribute | undefined;
  rightType?: HTMLInputTypeAttribute | undefined;
  leftPlaceholder?: string;
  rightPlaceholder?: string;
  showRightEdit?: boolean;
  onEditClick?: () => void;
  onDeleteClick?: () => void;
  leftDisabled?: boolean;
  rightDisabled?: boolean;
  leftError?: boolean;
}

export const FormTwoInputs = ({
  label,
  leftPlaceholder,
  rightPlaceholder,
  leftValue,
  rightValue,
  leftOnChange,
  rightOnChange,
  leftType,
  rightType,
  showRightEdit,
  onEditClick,
  onDeleteClick,
  leftDisabled,
  rightDisabled,
  leftError,
}: Props) => {
  /** State */
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      className="w-full mb-4"
    >
      <p className="mb-[12px] font-satoshi font-medium text-sm text-dark">
        {label}
      </p>
      <div className="flex flex-col sm:flex-row flex-1 items-start sm:items-center">
        <input
          value={leftValue}
          onChange={leftOnChange}
          type={leftType}
          placeholder={leftPlaceholder}
          disabled={leftDisabled}
          className={`w-full sm:w-1/2 sm:mr-2 mb-1 sm:mb-0 rounded border ${
            leftError ? "border-red-base" : "border-gray-border"
          } ${
            leftError ? "focus:border-red-base" : "focus:border-focused-border"
          } h-[46px] px-[14px] bg-sky-lighter font-satoshi font-medium text-base placeholder:text-gray-text text-dark outline-none`}
        />
        <input
          value={rightValue}
          onChange={rightOnChange}
          type={rightType}
          placeholder={rightPlaceholder}
          disabled={rightDisabled}
          className="w-full sm:w-1/2 sm:ml-2 rounded border border-gray-border focus:border-focused-border h-[46px] px-[14px] bg-sky-lighter font-satoshi font-medium text-base placeholder:text-gray-text text-dark outline-none"
        />
        {showRightEdit ? (
          <div
            className={`px-2 flex flex-row items-center mt-2 sm:mt-0 ${
              isHovered ? "opacity-100" : "opacity-100 sm:opacity-0"
            } transition ease-linear cursor-pointer`}
          >
            <Tooltip content="Edit">
              <EditIcon onClick={onEditClick} className="mr-3 sm:mr-7" />
            </Tooltip>
            <Tooltip content="Delete">
              <TrashIcon onClick={onDeleteClick} />
            </Tooltip>
          </div>
        ) : null}
      </div>
    </div>
  );
};
